import { UPDATE_TYPE } from "ineo/utils/constants";
import { TYPE_LINK } from "shared/utils/constants";
import { Button } from "shared/components/Button";
import styles from "./GridHeader.module.css";

export const GridHeader = ({
  children,
  title,
  lead,
  allLinkType = UPDATE_TYPE,
  link,
}) => (
  <>
    {(title || lead) && (
      <header className={styles.header}>
        <div>
          {title && <h2 className={styles.title}>{title}</h2>}
          {lead && <p className={styles.lead}>{lead}</p>}
        </div>
        {link && (
          <div className={styles.desktopShowAll}>
            <Button
              href={link.href || "#"}
              hrefType={allLinkType}
              type={TYPE_LINK}
            >
              {link.label}
            </Button>
          </div>
        )}
      </header>
    )}
    {children}
    {link && (
      <div className={styles.mobileShowAll}>
        <Button href={link.href} hrefType={allLinkType} type={TYPE_LINK}>
          {link.label}
        </Button>
      </div>
    )}
  </>
);
